import { render, staticRenderFns } from "./VideoPosterDLG.vue?vue&type=template&id=7403f793&scoped=true"
import script from "./VideoPosterDLG.vue?vue&type=script&lang=ts"
export * from "./VideoPosterDLG.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./VideoPosterDLG.vue?vue&type=style&index=0&id=7403f793&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7403f793",
  "3d75a85d"
  
)

export default component.exports